exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remark-info[data-v-407fb4ec]{margin-bottom:16px}.remark-info p[data-v-407fb4ec]{margin:0 0 4px;font-size:13px;color:#606266}", ""]);

// exports
